module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cNvRV"))).then(() => parcelRequire('ljYL6'));